import { Clock } from 'three'
import { Store } from 'Application/Store/Store'
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine'
import { showPontics, showGengivas, getTimes } from 'Domain/Scene/Handler/AnimationHandler'
import { updateElementsVisibility, setKeyframe } from './VisibilityManager'

const clock = new Clock()

export const updateAnimationState = (camera) => {
  const action = threeEngine.getAction()
  const mixer = threeEngine.getMixer()
  if (!action || !mixer) return

  const currentKeyframe = Store.getState().AnimationReducer.keyframe
  setKeyframe(currentKeyframe)
  const currentTime = getTimes()[currentKeyframe]

  action.time = currentTime
  mixer.update(clock.getDelta())

  showGengivas(currentKeyframe)
  showPontics(currentKeyframe)
  updateElementsVisibility(camera)
}
